const firebaseConfig = {
    apiKey: "AIzaSyAVBQdwHn7FFXDhf6F1-Ys9w1sCozXklGY",
    authDomain: "osud-dokan.firebaseapp.com",
    projectId: "osud-dokan",
    storageBucket: "osud-dokan.appspot.com",
    messagingSenderId: "1006617263106",
    appId: "1:1006617263106:web:b0f562820303db82fdbb1b"
  };
  export default firebaseConfig;